import { isImmediateDropAllowedWidget } from './webDashboardDropGeometry';

export const getConstrainedOrFallbackRect = ({
	left,
	top,
	width,
	height,
	currentWidgets,
	constrainRectToBackgroundImage,
}) => {
	const constrainedRect = constrainRectToBackgroundImage(
		left,
		top,
		width,
		height,
		currentWidgets,
	);

	return constrainedRect.constrained
		? constrainedRect
		: {
			left,
			top,
			width,
			height,
		};
};

export const isInvalidWidgetOverlap = ({
	rect,
	currentWidgets,
	draggedWidget,
	type,
	checkOverlap,
	currentWidgetId = null,
}) => (
	checkOverlap(
		rect.left,
		rect.top,
		rect.width,
		rect.height,
		currentWidgets,
		currentWidgetId,
		draggedWidget,
	) && !isImmediateDropAllowedWidget(type)
);

export const buildNewDashboardWidget = ({
	type,
	devices,
	t,
	propsFromType,
	getDefaultWidgetTitle,
	storeWidgetPosition,
	rect,
	metrics,
}) => storeWidgetPosition({
	id: type + Date.now(),
	data_id: 0,
	type,
	transparentBackground: false,
	title: getDefaultWidgetTitle(type, t),
	extra_props: propsFromType(type),
	...(devices?.length > 0 && { device_id: 0 }),
}, rect, metrics);
